import { useEffect, useRef } from "react";
import { useStore } from "../context/StoreContext";
import { track } from "../lib/analytics";
import { packTotal } from "../lib/format";
import { AnnouncementBar } from "../components/landing/AnnouncementBar";
import { Header } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { Problem } from "../components/landing/Problem";
import { Demo } from "../components/landing/Demo";
import { Benefits } from "../components/landing/Benefits";
import { Comparison } from "../components/landing/Comparison";
import { PackSelector } from "../components/landing/PackSelector";
import { UseCases } from "../components/landing/UseCases";
import { SocialProof } from "../components/landing/SocialProof";
import { Faq } from "../components/landing/Faq";
import { FinalCta } from "../components/landing/FinalCta";
import { Footer } from "../components/landing/Footer";
import { StickyATC } from "../components/landing/StickyATC";
import { CartDrawer } from "../components/landing/CartDrawer";

export default function LandingPage() {
  const { config } = useStore();
  const tracked = useRef(false);

  useEffect(() => {
    if (config && !tracked.current) {
      tracked.current = true;
      const pack = config.packs.find((p) => p.id === config.default_pack) || config.packs[0];
      track("ViewContent", {
        value: packTotal(pack),
        currency: "USD",
        content_ids: ["pelocero"],
        contents: [{ id: "pelocero", quantity: 1, price: Number(pack.price) }],
      });
    }
  }, [config]);

  if (!config) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="landing-loading">
        <div className="w-8 h-8 rounded-full border-2 border-brand border-t-transparent animate-spin" />
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen" data-testid="landing-page">
      <AnnouncementBar />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <Demo />
        <Benefits />
        <Comparison />
        <PackSelector />
        <UseCases />
        <SocialProof />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyATC />
      <CartDrawer />
    </div>
  );
}
